import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";
import { Dispatch } from "redux";
import { State } from "redux/state";

import { AdminGraphProps, AdminGraphView } from "../components/AdminGraphView";

type DispatchProps = {};
type StateProps = Pick<AdminGraphProps, "credentials">;
type OwnProps = {};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch: Dispatch) => {
    return {};
};

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => ({
    credentials: state.auth.credentials
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminGraphView);
